import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CONSTANTS } from '@shared/models/constants/constants';
import { Observable } from 'rxjs';
import { ENVIRONMENT, LoopEnvironment } from '@shared/environments/model';

@Injectable()
export class HttpProxyHelperInterceptor implements HttpInterceptor {
  private readonly environment: LoopEnvironment = inject(ENVIRONMENT);
  private externalLinks = [CONSTANTS.KLIPY_API, CONSTANTS.KLIPY_IMAGES, CONSTANTS.FILES_API];

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Replace domain so proxy can catch the request (solved CORS issues in development)
    if (this.environment.isUsingProxy && !this.externalLinks.some(link => request.url.includes(link))) {
      request = request.clone({
        url: request.url.replace(/^.*\/\/[^\/\?]+/, '')
      });
    }

    return next.handle(request);
  }
}
